import React, { Component, Fragment } from "react";
import { Row, Col, Form, Affix } from "antd";
import { YMaps } from "react-yandex-maps";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "./RequestCard.css";

// Redux Actions
import { checkCompanyVehiclesAndDrivers } from "../../redux/actions/requests";
import * as requestsActions from "../../redux/actions/requests";
import { interfaceActions } from "../../../../../common/redux/actions";

// URL Constants
import * as URLs from "../../../../../common/constants/systemUrls";

// Util functions
import { getNumberWithoutSpaces } from "../../../../../common/utils/format";

// Components
import FastForm from "../../components/RequestCard/Forms/FastForm";
import ReverseForm from "../../components/RequestCard/Forms/ReverseForm";
import Sidebar from "../../components/RequestCard/Sidebar/Sidebar";
import Controls from "../RequestCard/Controls/Controls";
import {
  closeSideDrawer,
  showSideDrawer
} from "../../../../../common/redux/actions/interfaceActions";
import RequisitesFormIP from "../../components/RequestCard/Forms/RequisitesFormIP";
import RequisitesFormUR from "../../components/RequestCard/Forms/RequisitesFormUR";
import RequisitesFormFIZ from "../../components/RequestCard/Forms/RequisitesFormFIZ";
import RouteMap from "../../components/RequestCard/RouteMap/RouteMap";
import RouteSchema from "../../components/RequestCard/RouteSchema/RouteSchema";
import SideDrawer from "../../../../../common/components/sideDrawer/sideDrawer";

const { getRequestsByProfile, updateRequest, getRequest } = requestsActions;

const { setCaption } = interfaceActions;

class RequestCard extends Component {
  state = {
    ymaps: false,
    distance: "",
    duration: ""
  };

  componentDidMount() {
    if (this.props.profile.profileId) {
      this.props.getRequest({
        profileId: this.props.profile.profileId,
        requestId: this.props.match.params.id
      });
    }

    if (this.props.request) {
      const { request, setCaption } = this.props;
      setCaption({
        enabled: true,
        mainCaption:
          request !== null &&
          `Заявка - ${getNumberWithoutSpaces(request.number)}`,
        breadCrumbs: [
          // Путь для хлебных крошек
          {
            path: "/" + URLs.CONTROL_PANEL,
            breadcrumbName: "Панель управления"
          },
          {
            path: `/${URLs.EXECUTORSHIP}/request`,
            breadcrumbName: "Исполнительство"
          },
          {
            path: "/" + URLs.REQUEST_CARD,
            breadcrumbName:
              request !== null && getNumberWithoutSpaces(request.number)
          }
        ]
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.profile.profileId !== prevProps.profile.profileId &&
      this.props.profile.profileId
    ) {
      this.props.getRequest({
        profileId: this.props.profile.profileId,
        requestId: this.props.match.params.id
      });
    }

    if (this.props.request !== prevProps.request && this.props.request) {
      let { request } = this.props;

      this.props.setCaption({
        enabled: true,
        mainCaption:
          request !== null &&
          `Заявка - ${getNumberWithoutSpaces(request.number)} ${
            request.requestStatusId.requestStatusId === 4 ? "(Скрыта)" : ""
          }`,
        breadCrumbs: [
          // Путь для хлебных крошек
          {
            path: "/" + URLs.CONTROL_PANEL,
            breadcrumbName: "Панель управления"
          },
          {
            path: `/${URLs.EXECUTORSHIP}/request`,
            breadcrumbName: "Исполнительство"
          },
          {
            path: "/" + URLs.REQUEST_CARD,
            breadcrumbName:
              request !== null && getNumberWithoutSpaces(request.number)
          }
        ]
      });
    }
    if (this.state.ymaps && !this.state.distance && !this.state.duration) {
      this.renderRoute();
    }

    if (
      this.props.request &&
      this.props.request.requestId &&
      prevProps.request &&
      prevProps.request.requestId &&
      this.props.request.requestId !== prevProps.request.requestId
    ) {
      this.renderRoute();
    }

    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.props.getRequest({
        profileId: this.props.profile.profileId,
        requestId: this.props.match.params.id
      });
    }
  }

  renderForm = () => {
    const { request } = this.props;
    const requestType = request.requestTypeId
      ? request.requestTypeId.requestTypeKey
      : "none";

    let form = null;

    switch (requestType) {
      case "fast":
        form = (
          <FastForm
            request={request}
            showDrawer={this.showDrawer}
            ref={el => {
              this.componentRef = el;
            }}
            componentRef={this.componentRef}
          />
        );
        break;
      case "reverse":
        form = <ReverseForm request={request} showDrawer={this.showDrawer} />;
        break;
      default:
        break;
    }
    return form;
  };

  renderRoute = () => {
    const markers = this.props.request.routes.map(route => {
      return [route.latitude, route.longitude];
    });

    const multiRoute = new this.state.ymaps.multiRouter.MultiRoute(
      {
        referencePoints: markers,
        params: {
          results: 1
        }
      },
      {
        boundsAutoApply: markers.length > 1
      }
    );

    multiRoute.events.add("update", () => {
      multiRoute.getRoutes().each(route => {
        const properties = route.properties.getAll();
        this.setState(() => ({
          distance: properties.distance.text,
          duration: properties.duration.text
        }));
      });
    });
  };

  renderDrawerHeader = id => {
    const { request } = this.props;

    switch (id) {
      case "requisitesPhysical":
        return (
          <div className="title">
            <p className="main">Реквизиты заказчика</p>
            <p className="sub">{request.profileId.companyId.nameLegal}</p>
          </div>
        );
      case "requisitesIndivid":
        return (
          <div className="title">
            <p className="main">Реквизиты заказчика</p>
            <p className="sub">{request.profileId.companyId.nameLegal}</p>
          </div>
        );
      case "requisitesLegal":
        return (
          <div className="title">
            <p className="main">Реквизиты заказчика</p>
            <p className="sub">{request.profileId.companyId.nameLegal}</p>
          </div>
        );
      case "routeMap":
        return (
          <div className="title">
            <p className="main">Схема маршрута</p>
            <p className="sub">Создание новой заявки</p>
          </div>
        );
      case "routeSchema":
        return (
          <div className="title">
            <p className="main">График движения</p>
            <p className="sub">Создание новой заявки</p>
          </div>
        );
      default:
        break;
    }
  };

  showDrawer = e => {
    this.props.showSideDrawer(e.target.id);
  };

  initYmaps = ymaps => {
    this.setState(() => ({
      ymaps: ymaps
    }));
  };

  render() {
    const {
      request,
      drawerId,
      closeSideDrawer,
      isDrawerVisible,
      form,
      checkCompanyVehiclesAndDrivers
    } = this.props;
    const { getFieldDecorator } = form;
    return (
      <div id="requestCard" className="basicForm">
        {request ? (
          <Fragment>
            <Row gutter={16}>
              <Col span={18}>{this.renderForm()}</Col>
              <Col span={6}>
                <Affix
                  offsetTop={18}
                  target={() => document.getElementById("mainSheet")}
                >
                  <Sidebar
                    request={request}
                    distance={this.state.distance}
                    duration={this.state.duration}
                    updateRequest={this.props.updateRequest}
                    checkCompanyVehiclesAndDrivers={
                      checkCompanyVehiclesAndDrivers
                    }
                  />
                </Affix>
              </Col>
            </Row>
            {request && request.requestId && (
              <Controls id={request.requestId} />
            )}
            <YMaps
              query={{
                apikey: "b6a66b8f-dc2c-4946-a916-0fb0ca680e5a"
              }}
              onApiAvaliable={ymaps => this.initYmaps(ymaps)}
            />
            <SideDrawer
              header={this.renderDrawerHeader(drawerId)}
              placement="left"
              width="896px"
              visible={isDrawerVisible}
              close={() => {
                closeSideDrawer();
              }}
              closable={true}
              drawerStyle={{ overflowY: "scroll", height: "100%" }}
              classes={drawerId === "routeMap" ? "no-padding" : null}
            >
              {drawerId === "requisitesPhysical" && (
                <RequisitesFormFIZ
                  request={request}
                  company={request.profileId.companyId}
                  decorator={getFieldDecorator}
                  form={form}
                />
              )}
              {drawerId === "requisitesIndivid" && (
                <RequisitesFormIP
                  request={request}
                  company={request.profileId.companyId}
                  decorator={getFieldDecorator}
                  form={form}
                />
              )}
              {drawerId === "requisitesLegal" && (
                <RequisitesFormUR
                  request={request}
                  company={request.profileId.companyId}
                  decorator={getFieldDecorator}
                  form={form}
                />
              )}
              {drawerId === "routeMap" && (
                <RouteMap
                  markers={request.routes.map(route => [
                    route.latitude,
                    route.longitude
                  ])}
                  routes={request.routes.length && request.routes}
                />
              )}
              {drawerId === "routeSchema" && (
                <RouteSchema
                  routes={request.routes.length && request.routes}
                  landingTime={request.arrivalDateTime}
                  using={request.usingTime}
                  distance={this.state.distance}
                  duration={this.state.duration}
                />
              )}
            </SideDrawer>
          </Fragment>
        ) : null}
      </div>
    );
  }
}

export default Form.create()(
  connect(
    state => ({
      request: state.Executorship.Requests.requests.requestById,
      profile: state.Authorization.activeProfile,
      drawerId: state.Interface.sideDrawer.drawer.id,
      isDrawerVisible: state.Interface.sideDrawer.drawer.isVisible
    }),
    {
      getRequestsByProfile,
      getRequest,
      setCaption,
      updateRequest,
      showSideDrawer,
      closeSideDrawer,
      checkCompanyVehiclesAndDrivers
    }
  )(withRouter(RequestCard))
);
